import { browserName, browserVersion, osName, osVersion } from 'react-device-detect'
import { v4 as uuidv4 } from 'uuid'
import { ANALYTICS_SESSION_THRESHOLD } from '@wellbeingxltd/fe-lib/constants'
import { submitToApi } from 'awsApi'
import { URL } from './endpoints'

const generateAnalyticsSession = newId => {
    const now = +new Date()

    localStorage.setItem(
        'analyticsSession',
        JSON.stringify({
            sessionId: newId ? `session_${uuidv4()}_${now}` : JSON.parse(localStorage.getItem('analyticsSession')).sessionId,
            sessionLastUpdated: now,
        })
    )
}

const checkAnalyticsSessionThreshold = () => {
    const now = +new Date()
    const sessionLastUpdated = JSON.parse(localStorage.getItem('analyticsSession')).sessionLastUpdated

    if (now - sessionLastUpdated > ANALYTICS_SESSION_THRESHOLD) {
        generateAnalyticsSession(true)
    } else {
        generateAnalyticsSession(false)
    }
}

// Setup sessionId on launch
if (localStorage.getItem('analyticsSession')) {
    checkAnalyticsSessionThreshold()
} else {
    generateAnalyticsSession(true)
}

export const postAnalytics = (click, to) => async dispatch => {
    checkAnalyticsSessionThreshold()
    try {
        await submitToApi({
            body: {
                click,
                to,
                device: `WEB | ${osName} | ${osVersion} | ${browserName} | ${browserVersion}`,
                sessionId: JSON.parse(localStorage.getItem('analyticsSession')).sessionId,
            },
            method: 'POST',
            path: URL.ANALYTICS.V3_ANALYTICS_USER_CREATE,
            url: URL.ANALYTICS.BASE,
        })
    } catch (error) {
        console.log('postAnalytics error', error)
    }
}
